import cookies from 'js-cookie';

import { SchoolAutoDiscoverState } from './types';

export const getDiscoverFromCookie = (): SchoolAutoDiscoverState => {
  let discoverOnCookie = cookies.get('autoDiscover');

  if (discoverOnCookie) {
    const discover = JSON.parse(discoverOnCookie) as SchoolAutoDiscoverState;
    return discover;
  }

  return undefined!;
};
